import { render, staticRenderFns } from "./SystemWarnings.vue?vue&type=template&id=5e7e983b&"
import script from "./SystemWarnings.vue?vue&type=script&lang=js&"
export * from "./SystemWarnings.vue?vue&type=script&lang=js&"
import style0 from "./SystemWarnings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports